// extracted by mini-css-extract-plugin
export default {"messageContainer":"JEl42DlNYg1whc1rELbc","imgContainer":"zx6aCm8ICSCzmQl_bd1w","dash":"uzGLV5OsSSP6cUOtAI3E"};